'use strict';

var _ = require('lodash');
var InlineBarChartController = function InlineBarChartController($rootScope, $scope, $filter) {
  var rmNumberFormat = $filter('rmNumberFormat');
  $scope.$watchGroup(['frontBarValue', 'backBarValue', 'maxValue'], function () {
    var frontBarFraction = $scope.frontBarValue / $scope.maxValue;
    var backBarFraction = $scope.backBarValue / $scope.maxValue;
    if (_.isFinite(frontBarFraction)) {
      $scope.setFrontBarWidth(frontBarFraction);
    }
    if (_.isFinite(backBarFraction)) {
      $scope.setBackBarWidth(backBarFraction);
    }
    $scope.isTile = $scope.backBarValue < $scope.frontBarValue;
    $scope.displayMaxValue = rmNumberFormat($scope.maxValue, 'NUMBER');
  });
};
InlineBarChartController.$inject = ['$rootScope', '$scope', '$filter'];
module.exports = InlineBarChartController;